/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

import {
  PspToken,
  PspTokenApiResponse,
  pspTokenFromApiResponse,
} from '@shared/models/psp-token';

export interface EntityToken {
  financialEntityId?: string;
  integratorId?: string;
  participantId?: string;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
  token?: PspToken;
  id?: string;
}

export interface EntityTokenApiResponse {
  institution_id?: string;
  integrator_id?: string;
  participant_id?: string;
  name?: string;
  created_at?: string;
  updated_at?: string;
  token?: PspTokenApiResponse;
  id?: string;
}

export const entityTokenFromApiResponse = (response: EntityTokenApiResponse): EntityToken => {
  return {
    ...(response.institution_id && {financialEntityId: response.institution_id}),
    ...(response.integrator_id && {integratorId: response.integrator_id}),
    ...(response.participant_id && {participantId: response.participant_id}),
    ...(response.id && {id: response.id}),
    ...(response.name && {name: response.name}),
    ...(response.created_at && {createdAt: response.created_at}),
    ...(response.updated_at && {updatedAt: response.updated_at}),
    ...(response.token && {token: pspTokenFromApiResponse(response.token)}),
  };
};
